import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  FaFileAlt,
  FaShieldAlt,
  FaQuestionCircle,
  FaImage,
  FaStar,
  FaMedal,
  FaQuoteRight,
  FaThLarge
} from 'react-icons/fa';

const modules = [
  {
    key: 'terms',
    name: 'Terms of Use',
    description: 'Manage legal terms and version history.',
    icon: FaFileAlt,
    path: '/admin/site-management/terms'
  },
  {
    key: 'privacy',
    name: 'Privacy Policy',
    description: 'Configure privacy policy content and updates.',
    icon: FaShieldAlt,
    path: '/admin/site-management/privacy'
  },
  {
    key: 'faqs',
    name: 'FAQ',
    description: 'Create categories, questions and ordering.',
    icon: FaQuestionCircle,
    path: '/admin/site-management/faqs'
  },
  {
    key: 'banners',
    name: 'Banners',
    description: 'Schedule, prioritize and manage banners.',
    icon: FaImage,
    path: '/admin/site-management/banners'
  },
  {
    key: 'features',
    name: 'Features',
    description: 'Highlight product features for your landing page.',
    icon: FaThLarge,
    path: '/admin/site-management/features'
  },
  {
    key: 'awards',
    name: 'Awards',
    description: 'Showcase your organization awards.',
    icon: FaMedal,
    path: '/admin/site-management/awards'
  },
  {
    key: 'testimonials',
    name: 'Testimonials',
    description: 'Manage customer quotes and success stories.',
    icon: FaQuoteRight,
    path: '/admin/site-management/testimonials'
  },
  {
    key: 'landing-page',
    name: 'Landing Page',
    description: 'Configure sections with live preview.',
    icon: FaStar,
    path: '/admin/site-management/landing-page'
  }
];

const SiteManagementDashboard = () => {
  const navigate = useNavigate();

  const handleCardClick = (path) => {
    navigate(path);
  };

  return (
    <div className="p-3 sm:p-6 md:p-8 bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50 min-h-screen">

      {/* Header */}
      <div className="mb-3 sm:mb-10">
        <h1 className="fw-bold mb-0 text-xl sm:text-2xl md:text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600">
          Site Management
        </h1>
      </div>

      {/* Cards Grid */}
      <div className="grid gap-6 sm:gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {modules.map((mod) => {
          const Icon = mod.icon;
          return (
            <button
              key={mod.key}
              type="button"
              onClick={() => handleCardClick(mod.path)}
              className="group relative overflow-hidden rounded-3xl bg-white/90 backdrop-blur-xl border border-purple-200/50 shadow-lg hover:shadow-2xl hover:shadow-purple-500/30 transform hover:-translate-y-3 transition-all duration-300 ease-out"
            >
              {/* Gradient Overlay on Hover */}
              <div className="absolute inset-0 bg-gradient-to-br from-purple-500/10 to-pink-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

              <div className="relative p-4 sm:p-8 text-left">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-4">
                    <div className="p-3 rounded-2xl bg-gradient-to-br from-purple-600 to-pink-600 shadow-xl group-hover:scale-110 transition-transform duration-300">
                      <Icon className="w-8 h-8 text-white" />
                    </div>
                    <h2 className="text-xl sm:text-xl font-bold text-gray-800 group-hover:text-purple-700 transition-colors">
                      {mod.name}
                    </h2>
                  </div>
                </div>

                <p className="text-sm sm:text-base text-gray-600 leading-relaxed font-medium">
                  {mod.description}
                </p>

                {/* Bottom Arrow Indicator */}
                {/* <div className="mt-6 flex justify-end opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="p-3 bg-purple-100 rounded-full group-hover:bg-purple-600 transition-all">
                    <svg className="w-5 h-5 text-purple-600 group-hover:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div> */}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SiteManagementDashboard;